import React from 'react';

import CadastroComposicaoContent from './CadastroComposicaoContent';
import { CadastroComposicaoProvider } from './context/CadastroComposicaoContext';

const CadastroComposicao: React.FC = () => {
  return (
    <CadastroComposicaoProvider>
      <CadastroComposicaoContent />
    </CadastroComposicaoProvider>
  );
};

export default CadastroComposicao;
